<template>
  <div class="invoice-single" :key="$route.path">
    <div
      v-if="invoiceLoading"
      class="d-flex align-items-center justify-content-center w-100"
    >
      <loader :height="500" />
    </div>
    <v2
      v-else-if="invoice && !invoiceLoading && version >= 0"
      :invoice="invoice"
      @trigger-esign="loadInvoice(true)"
      :discrepant-invoices="discrepantInvoices"
      @update-discrepant-invoices="updateDiscrepantInvoices"
    />
    <div v-else class="d-flex align-items-center justify-content-center w-100">
      {{ $t('invoices.single.failedToLoad') }}
    </div>
    <discrepant-success-modal
      :show="discrepantInvModal"
      @close="discrepantInvModal = false"
    />
  </div>
</template>
<script>
import V2 from '@/components/invoices/Details/DisplayV2'
import Loader from '@/components/common/Loader'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import invoiceService from '@/services/invoice'
import userService from '@/services/user'
import DiscrepantSuccessModal from '@/components/invoices/modals/DiscrepantSuccessModal'

export default {
  data() {
    return {
      invoice: null,
      version: parseInt(this.$store.state.account.portalVersion),
      discrepantInvoices: null,
      discrepantInvModal: false,
      invoiceLoading: false
    }
  },
  created() {
    this.loadInvoice()
  },
  mounted() {
    this.$mpTrack('Single Invoices page mounted')
  },
  methods: {
    async loadInvoice(updateAlerts = false) {
      this.invoiceLoading = true
      const [res, discrepantData] = await Promise.all([
        invoiceService.fetchInvoicesById(this.$route.params.id, {
          include: [
            'plan',
            'customer_pending_task_flows',
            'task_flows',
            'payment',
            'info',
            'exporter',
            'advances',
            'fees',
            'shipping_data',
            'form_data',
            'client_bank_detail',
            'statement_data',
            'fees_breakup_detailed'
          ]
        }),
        userService
          .fetchAccessToken()
          .then((r) =>
            invoiceService.getDiscrepantInvoices(
              this.$route.params.id,
              r.data.token
            )
          )
      ])

      this.discrepantInvoices = discrepantData.data.discrepant_document || []

      if (updateAlerts) {
        this.invoice.customer_pending_task_flows =
          res && res.data && res.data.customer_pending_task_flows
        return
      }
      this.invoice = res.data
      this.invoiceLoading = false
      if (this.$store.state.account.country === 'India') {
        this.showAndPrefillFreshdesk(
          {
            cf_category_i: 'Invoice related',
            cf_importer_id: this.invoice.importer_user_id,
            cf_importer_name: this.invoice.importer,
            cf_client_id: this.invoice.client_id,
            cf_invoice_id: this.invoice.id,
            cf_invoice_reference: this.invoice.reference,
            cf_link_to_dashboard: `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/invoices/${this.invoice.id}`
          },
          `Support Ticket | ${this.invoice.reference} | Drip Capital`
        )
      }
    },
    updateDiscrepantInvoices(docKey) {
      this.discrepantInvoices = this.discrepantInvoices.filter(
        (i) => !docKey.startsWith(i.document_type)
      )
      if (!this.discrepantInvoices.length) {
        this.discrepantInvModal = true
      }
    }
  },
  components: {
    Loader,
    V2,
    DiscrepantSuccessModal
  },
  watch: {
    $route() {
      this.loadInvoice()
    }
  },
  mixins: [freshdeskMixin]
}
</script>
